import type { FaireProductEntity } from "../../entity_types/product";

export const p_ja7stvpa9r: FaireProductEntity = {
  token: "p_ja7stvpa9r",
  type: "product",
  name: "Chupa Chups Taste Bud Party Lollipops - Orange Soda & Tropical Fruit (48x15g) (China)",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/323a25f14a0f6395c1a7c79f7163c0a007a5dc5e8eef4a836879e106cfad7e8f.jpeg",
  galleryImageUrls: [],
  priceDollars: 40,
  description:
    "Chupa Chups Taste Bud Party Lollipops feature orange soda & tropical fruit flavors. Includes 48 lollipops in a collectible glass mug display. 🍊🍍🍭\n\nKey Features:\n\n * \n🍭 48 lollipops (15g each) in one party-ready assortment\n\n * \n🍊 Orange Soda and 🍍 Tropical Fruit flavor mix\n\n * \n🥤 Includes collectible glass mug display as shown in the product image\n\n * \n📦 Eye-catching retail display perfect for counters or candy tables\n\n * \n🇨🇳 Imported from China\n\n * \n🎉 Ideal for parties, candy buffets, novelty displays, and gifting\n",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:41.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
